module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a8-2-9ecb1bda7ff015c55ba8cd1524ec13c5.jpg";